// extracted by mini-css-extract-plugin
export default {"list":"RegistrationStatic_list__0hln9","select":"RegistrationStatic_select__kJCB5"};